"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsAuthenticatedCookie = exports.getIsAuthenticatedCookie = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _makeCookieName = require("./makeCookieName");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cookieName = (0, _makeCookieName.makeCookieName)("isAuthenticated");

var getIsAuthenticatedCookie = function getIsAuthenticatedCookie() {
  var cookies = new _universalCookie["default"]();
  return cookies.get(cookieName);
};

exports.getIsAuthenticatedCookie = getIsAuthenticatedCookie;

var setIsAuthenticatedCookie = function setIsAuthenticatedCookie(value) {
  var cookies = new _universalCookie["default"]();
  cookies.set(cookieName, value);
  return cookies.get(cookieName);
};

exports.setIsAuthenticatedCookie = setIsAuthenticatedCookie;